import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieConsent } from "./CookieConsent";
import { Seo } from "./Seo";
import { Toaster } from "./ui/sonner";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

export const Layout = () => (
  <>
    <Seo />
    <ScrollToTop />
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
    <CookieConsent />
    <Toaster position="top-right" richColors />
  </>
);
